'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.btnReset = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _reactRouter = require('react-router');

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

var _fonts = require('@quixeltools/quixel-ui-library/dist/utils/fonts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textInput = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1)
});

var foot = (0, _glamor.css)(_css.clearfix, {
  display: 'block',

  marginTop: (0, _css.unitRem)(2),
  textAlign: 'center'
}, (0, _css.minWidth)(_css.breakpoints.medium)({}));

var submitButton = (0, _glamor.css)({
  position: 'relative',
  margin: '0 auto'
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  float: 'right',
  display: 'block'
}));
var _popup = function _popup(flag) {
  return (0, _glamor.css)({
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    width: '100%',
    height: 60,
    zIndex: 10000,
    top: 0,
    background: '#2b98f0',
    backgroundBlendMode: ' color, normal',
    backgroundImage: 'linear-gradient(to bottom, #2b98f0, #2b98f0), linear-gradient(135deg, #8cc152, #50ae55)',
    paddingTop: '1.1rem'
  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
    flexDirection: 'column',
    paddingTop: '0px'
  }));
};
var container = function container(flag) {
  return (0, _glamor.css)({
    position: flag ? 'absolute' : 'unset',
    width: flag ? '100%' : 'unset',
    textAlign: 'center',
    verticleAlign: 'middle',
    letterSpacing: '1.2px',
    lineHeight: 1.6,
    fontWeight: 700,
    top: flag ? "50%" : 'unset',
    left: flag ? "50%" : 'unset',
    transform: flag ? "translate(-50%, -50%)" : 'unset'
  }, (0, _polyfluid.polyfluid)({
    fontSize: {
      small: [0.7, 1],
      medium: [0.9],
      large: [0.9, 1.1]
    }

  }));
};

var container1 = function container1(flag) {
  return (0, _glamor.css)({
    position: 'absolute',

    textAlign: 'center',
    letterSpacing: '1.2px',
    fontWeight: 700,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }, (0, _polyfluid.polyfluid)({
    fontSize: {
      small: [0.7, 1],
      medium: [1],
      large: [1, 1.2]
    }
  }));
};

var title = (0, _glamor.css)({
  verticalAlign: 'middle'
}, (0, _polyfluid.polyfluid)({
  marginRight: {
    small: [0.3, 0.3],
    medium: [0.3],
    large: [0.3, 0.4]
  }
}));
var btnReset = exports.btnReset = (0, _glamor.css)({
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  color: 'inherit',
  textAlign: 'left',

  ':focus': {
    outline: 'none'
  }
});
var close = function close(flag) {
  return (0, _glamor.css)(btnReset, {
    position: 'absolute',
    top: '1.2rem',
    right: '1.4vw',
    zIndex: 1,
    width: (0, _css.unitRem)(1),
    height: (0, _css.unitRem)(1),
    cursor: 'pointer',
    transition: 'all ' + time.fast,
    color: '#fff',

    ':hover': {
      transform: 'scale(1.1, 1.1)',
      color: '#aaa'
    },
    ':after': {
      content: '"✕"',
      width: '100%'
    }
  }, (0, _polyfluid.polyfluid)({
    top: {
      large: [1.2, 1.2]
    },
    right: {
      small: [0.5, 1.2],
      medium: [1.2],
      large: [1.2, 1.2]
    },
    fontSize: {
      small: [1.1, 1.2],
      medium: [1.2],
      large: [1.2, 1.2]
    }
  }), (0, _css.maxWidth)(_css.breakpoints.medium)({
    top: flag ? '1.3rem' : '1.6rem'
  }));
};

var button = (0, _glamor.css)({
  verticalAlign: 'middle',
  display: 'inline-block',
  '& button': {
    verticalAlign: 'middle',
    color: '#2b98f0',
    background: '#fff',
    paddingTop: '0.5em',
    paddingBottom: '0.5em',
    fontWeight: 700

  },
  '& a': {
    verticalAlign: 'middle',
    color: '#2b98f0',
    background: '#fff',
    paddingTop: '0.5em',
    paddingBottom: '0.5em',
    fontWeight: 700,
    '& span': {
      display: 'inline-block'
    }
  }

});
var buttonContainer = (0, _glamor.css)({ display: 'inline-block' }, (0, _css.maxWidth)(_css.breakpoints.medium)({
  marginTop: '0.8rem',
  display: 'block'
}));
var text = (0, _glamor.css)(_fonts.textBtn1, {
  textTransform: 'uppercase',
  '& a': {
    color: _css.colors.white
  }
});

var ArchvizBanner = function (_React$Component) {
  (0, _inherits3.default)(ArchvizBanner, _React$Component);

  function ArchvizBanner(props) {
    (0, _classCallCheck3.default)(this, ArchvizBanner);
    return (0, _possibleConstructorReturn3.default)(this, (ArchvizBanner.__proto__ || (0, _getPrototypeOf2.default)(ArchvizBanner)).call(this, props));
  }

  (0, _createClass3.default)(ArchvizBanner, [{
    key: 'render',
    value: function render() {
      var countDown = this.state;
      var props = this.props;
      return _react2.default.createElement(
        'section',
        {
          className: (0, _glamor.css)(_popup(false))
        },
        _react2.default.createElement(
          'div',
          { className: container(false) },
          _react2.default.createElement(
            'span',
            { className: text },
            props.content,
            ' ',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: props.linkTo },
              props.linkLabel
            )
          )
        )
      );
    }
  }]);
  return ArchvizBanner;
}(_react2.default.Component);

exports.default = ArchvizBanner;


//////////////////
// WEBPACK FOOTER
// ./src/components/ArchvizBanner/ArchvizBanner.jsx
// module id = 2642
// module chunks = 0